import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-skeleton-messages',
  templateUrl: './skeleton-messages.component.html',
  styleUrls: ['./skeleton-messages.component.scss']
})
export class SkeletonMessagesComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
